module.exports = __webpack_public_path__ + "img/ad-qrcode.880612e7.gif";